import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.initializeAddressInputs();
  }

  initializeAddressInputs() {
    this.element.querySelectorAll(".address-input").forEach(input => {
      this.initializeAddressInput(input);
    });
  }

  initializeAddressInput(addressInput) {
    const container = addressInput.closest(".address-form-item");
    const streetAddressInput = container.querySelector(
      ".address-input-street-address"
    );
    const postcodeInput = container.querySelector(".address-input-postcode");
    const cityInput = container.querySelector(".address-input-city");

    if (addressInput) {
      // Initialize Google Maps autocomplete for this input
      if (window.google && window.google.maps && window.google.maps.places) {
        this.initGoogleAutocomplete(addressInput, postcodeInput, cityInput);
      } else if (window.initGoogleAutocomplete) {
        window.initGoogleAutocomplete(addressInput);
      }
    }
  }

  initGoogleAutocomplete(addressInput, postcodeInput, cityInput) {
    const autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ["address"]
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (place.address_components) {
        // Extract postal code
        const postalCodeComponent = place.address_components.find(component =>
          component.types.includes("postal_code")
        );
        if (postalCodeComponent && postcodeInput) {
          postcodeInput.value = postalCodeComponent.long_name;
        }

        // Extract city
        const cityComponent = place.address_components.find(component =>
          component.types.includes("locality")
        );
        if (cityComponent && cityInput) {
          cityInput.value = cityComponent.long_name;
        }
      }
    });
  }

  addAddress(event) {
    event.preventDefault();

    // Get the current number of addresses
    const addressesList = this.element.querySelector(".addresses-list");
    const addressCount = addressesList.querySelectorAll(".address-form-item")
      .length;

    // Create a new address form template
    const template = `
      <div class="address-form-item">
        <div class="address-form-item__header">
          <h4>Adresse ${addressCount + 1}</h4>
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_name">Type d'adresse</label>
          <input class="string" placeholder="Bureau principal, Entrepôt, etc." type="text" name="firm[addresses_attributes][${addressCount}][name]" id="firm_addresses_attributes_${addressCount}_name">
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_street_address">Adresse complète</label>
          <input class="string address-input" type="text" name="firm[addresses_attributes][${addressCount}][street_address]" id="firm_addresses_attributes_${addressCount}_street_address">
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_zip">Code postal</label>
          <input class="string address-input-postcode" placeholder="93100" type="text" name="firm[addresses_attributes][${addressCount}][zip]" id="firm_addresses_attributes_${addressCount}_zip">
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_city">Ville</label>
          <input class="string address-input-city" placeholder="Aubervilliers" type="text" name="firm[addresses_attributes][${addressCount}][city]" id="firm_addresses_attributes_${addressCount}_city">
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_operation_hours">Heures d'ouverture</label>
          <input class="string" placeholder="Lun-Ven 9h-18h" type="text" name="firm[addresses_attributes][${addressCount}][operation_hours]" id="firm_addresses_attributes_${addressCount}_operation_hours">
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_access_code">Code d'accès</label>
          <input class="string" placeholder="A1234" type="text" name="firm[addresses_attributes][${addressCount}][access_code]" id="firm_addresses_attributes_${addressCount}_access_code">
        </div>
        <div class="input string">
          <label for="firm_addresses_attributes_${addressCount}_floor">Étage</label>
          <input class="string" placeholder="3ème étage" type="text" name="firm[addresses_attributes][${addressCount}][floor]" id="firm_addresses_attributes_${addressCount}_floor">
        </div>
      </div>
    `;

    // Add the new address form to the list
    addressesList.insertAdjacentHTML("beforeend", template);

    // Get references to the newly added inputs
    const newAddressForm = addressesList.lastElementChild;
    const newAddressInput = newAddressForm.querySelector(".address-input");
    const newPostcodeInput = newAddressForm.querySelector(
      ".address-input-postcode"
    );
    const newCityInput = newAddressForm.querySelector(".address-input-city");

    // Initialize the new address input
    if (newAddressInput) {
      // Try to initialize using our internal method first
      if (window.google && window.google.maps && window.google.maps.places) {
        this.initGoogleAutocomplete(
          newAddressInput,
          newPostcodeInput,
          newCityInput
        );
      }
      // Fall back to the global function if available
      else if (window.initGoogleAutocomplete) {
        window.initGoogleAutocomplete(newAddressInput);
      }
    }
  }
}
